import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    unreadCount: 0,
  },
  reducers: {
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload);
      state.unreadCount += 1;
    },
    markAllAsRead: (state) => {
      state.notifications = state.notifications.map(notification => ({
        ...notification,
        is_read: true
      }));
      state.unreadCount = 0;
    },
    markAsRead: (state, action) => {
      const notificationId = action.payload;
      state.notifications = state.notifications.map(notification =>
        notification.id === notificationId
          ? { ...notification, is_read: true }
          : notification
      );
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload;
    },
    setUnreadCount: (state, action) => {
      const count = Number(action.payload);
      state.unreadCount = isNaN(count) ? 0 : count;
    },
    appendNotifications: (state, action) => {
      state.notifications = [...state.notifications, ...action.payload];
    },
  },
});

export const {
  addNotification,
  markAllAsRead,
  markAsRead,
  setNotifications,
  setUnreadCount,
  appendNotifications
} = notificationSlice.actions;

export default notificationSlice.reducer;